export default {
  en: {
    landing: {
      recentSupplier: 'Recently visited suppliers',
      recentClient: 'Recently visited clients',
      recentEmpty: 'No recently viewed organisations',
      supplier: 'Supplier',
      client: 'Client',
    },
    filters: {
      connectedStatusConnected: 'Connected',
      connectedStatusNotConnected: 'Not connected',
      orgTypeClient: 'Client',
      orgTypeSupplier: 'Supplier',
    },
    org: {
      trialRestricted: 'Trial restricted',
      trialRestrictedDescription: 'This profile is not included in your trial.',
    },
    results: {
      cantFindSupplier: "Can't find the supplier you're looking for?",
      noMatches: 'No matching results',
      tryDifferentSearch: 'Try searching for something else or change your filters.',
      createNewSupplier: 'Create new supplier {name}',
      createSupplier: 'Create supplier',
      noResults: 'No results found',
      popularSuppliers: 'Popular suppliers',
      popularClients: 'Popular clients',
      managedProfiles: 'Managed profiles',
      availableSuppliers: 'Available suppliers',
      resultsCount: '{n} result | {n} results',
      resultsCountOrMore: '{count}+ results',
      connectWith: 'Connect with {name}',
      connectionRequestSent: 'Request sent',
      connectionRequestReceived: 'Request received',
    },
    bar: {
      searchSupplier: 'Search for a supplier...',
      searchClient: 'Search for a client...',
      failed: 'Search failed',
      search: 'Search',
    },
    nav: {
      title: 'Search',
      searchSuppliers: 'Search suppliers',
      searchClients: 'Search clients',
    },
  },
};
